import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';
import { List } from 'react-virtualized';

class EMIIssuerFilter extends Component {
    state = {
          emiIssuerLists:[],
            emiIssuerValue:'',
//             emiIssuerIDs:'',
    };
    componentDidMount(){
        this._getEmiIssure();
    }
    resetEMIIssuerFilter(){
        this.setState({
        emiIssuerValue: [],
        })
    }


     _getEmiIssure(){
        axios.get(config.get('API_URL')+'/reports/all_emi_issuing_banks/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
                this.setState({
                    emiIssuerLists:[]
                })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((issuer, index) => {
                    this.state.emiIssuerLists.push({value: issuer.emi_bank_code, label: issuer.issuer_bank_display_name})
                });
            }
        });
    }
    changeEmiIssuer(login_type, optionSelected){
        let value='';
        let emiIssuerArray = [];
        if(optionSelected.length < 1){
            value = null;
            emiIssuerArray= '';
        }
        else{
            optionSelected.map((mids, i) => {
                if(login_type=='Issuing Bank'){
                    emiIssuerArray.push(mids.value)
                }
                else {
                    emiIssuerArray.push(mids.value)
//                     var index = this.state.emiIssuerLists.findIndex(obj => obj.value == mids.value);
//                     this.state.emiIssuerLists.move(index, 0).join(',');
                }
            });
        }
        this.props.onSelectEMIIssuer(optionSelected, emiIssuerArray);
//         var is_enable = compareValues(emiIssuerArray, this.state.active_emiIssuerIDs);
        this.setState({
//             emiIssuerIDs:emiIssuerArray,
            emiIssuerValue:optionSelected,
//             isChange: is_enable
        });
        // this.get_filtered_emi_transaction_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.is_void, this.state.subventionIDs, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.emiSchemeIDs, this.state.tenureIDs, emiIssuerArray, this.state.txnTypeIDs, this.state.ciutidIds, this.state.isSettledIDs)
    }
    render() {
              const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }

        return (
            <ReactMultiSelectCheckboxes name="emi_issure"
            isMulti
            components={{ MenuList }}
            value={this.state.emiIssuerValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changeEmiIssuer.bind(this,'')}
            options={this.state.emiIssuerLists}
            placeholderButtonLabel="Select [EMI Issuer]"
        />
        );

    }
}
export default EMIIssuerFilter;